import { Icon, Box } from "@chakra-ui/react"
import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg';
import { FC, useEffect, useState } from 'react';
import { useRouter } from "next/router";
import { packsClient } from 'lib/clients';
import Image from 'next/image';

export const LinkIcon: FC<any> = ({ assetId, iconHash }) => {
  const [ icon, setIcon ] = useState<any>(undefined);
  const { query: { id } } = useRouter();

  useEffect(() => {
    if (!iconHash) {
      setIcon(undefined);
      return;
    }

    (async() => {
      try {
        const { data } = await packsClient.getIcon(id as string, assetId);
        let base64ImageString = Buffer.from(data, 'binary').toString('base64');
        setIcon("data:image/png;base64,"+base64ImageString);
      } catch (err) {
        // Fallback for when there's no icon
      }
    })();

  }, [iconHash, assetId, id]);

  if (icon) {
    return (
      <Box width={"100%"} height={"30px"} position={"relative"}>
        <Image
          src={icon}
          alt="link icon"
          layout="fill"
          objectFit="contain"
        />
      </Box>
    )
  }

  return (
    <Box width={"100%"} height={"30px"} position={"relative"}>
      <Icon as={BsLink45Deg} color={"brand.500"} boxSize={["20px", "30px"]} />
    </Box>
  )
}
